import React, { useState } from "react";
import { connect } from "react-redux";
import { css } from "emotion";

import Callout from "../../../../../../shared/create-offer/Callout/Callout";
import ModalLatamPhone from "../../../../../../shared/create-offer/ModalPhoneLatam/ModalLatamPhone";

import { boxOfferRegisteredStyle } from "./style";
import { useNewOffer } from "../../../../../context/new-offer";
import { setFidelityPhoneByFidelityId } from "../../../../../shared/requests-api";
import { refreshOffers } from "../../../../../actions";

const EditOfferRegistered = ({ refreshOffers, typePhoneLatam }) => {
	const {
		currentProgram,
		loyaltyData,
		setLoyaltyData,
		phoneMultiplus,
		twoFactorData
	} = useNewOffer();

	const { phone, isMaxPhone, id } = loyaltyData.data;
	const phoneMMSuggestion = phoneMultiplus;
	const [showModalPhone, setShowModalPhone] = useState(false);

	const onChangePhone = phone => {
		let phoneMax = 0;
		setFidelityPhoneByFidelityId(id, phone).then(() => {
			if (phoneMMSuggestion === phone) {
				phoneMax = 1;
			} else {
				phoneMax = 0;
			}

			setLoyaltyData({
				...loyaltyData,
				data: { ...loyaltyData.data, isMaxPhone: phoneMax, phone: phone }
			});

			refreshOffers();

			setShowModalPhone(false);
		});
	};

	const isLatam = () => {
		return currentProgram.id === 3 || currentProgram.id === 1;
	};

	const isWrongLatamPhone = isLatam() && isMaxPhone === 0;
	const isDisabledLatamPhone = isLatam() && isMaxPhone === -1;

	return (
		<div
			className={css`
				${boxOfferRegisteredStyle}
			`}
		>
			<div
				className={`area-icon ${
					(isWrongLatamPhone || isDisabledLatamPhone) && typePhoneLatam === 0
						? "wrong-phone-area-icon"
						: ""
				}`}
			>
				<i
					className={
						(isWrongLatamPhone || isDisabledLatamPhone) && typePhoneLatam === 0
							? "icon-close"
							: "icon-check"
					}
				/>
			</div>
			<div className="area-text">
				<p className="area-text--title">
					{(isWrongLatamPhone || isDisabledLatamPhone) && typePhoneLatam === 0
						? "Oferta Reprovada!"
						: "Oferta cadastrada com sucesso!"}
				</p>
				<p>
					{(isWrongLatamPhone || isDisabledLatamPhone) && typePhoneLatam === 0
						? isWrongLatamPhone
							? "Não será possível vender suas milhas porquê você não cadastrou o número de celular da MaxMilhas no seu cadastro do Latam Pass."
							: "Não será possível vender suas milhas porquê o número do celular da MaxMilhas que você tem cadastrado no Latam Pass não está mais ativo."
						: "Sua oferta será analisada e, em até 5 dias úteis, você receberá nossa confirmação por e-mail."}
				</p>
			</div>

			<Callout
				show={isWrongLatamPhone && typePhoneLatam === 0}
				criticalWarn
				text={
					<span>
						<strong>
							Atenção! É obrigatório alterar o número de telefone da MaxMilhas no seu cadastro do
							Latam Pass. Para alterar,
						</strong>
						<a
							onClick={() => {
								setShowModalPhone(true);
							}}
							className="area-text--link"
						>
							<strong>clique aqui.</strong>
						</a>
					</span>
				}
			/>

			<Callout
				show={isDisabledLatamPhone && typePhoneLatam === 0}
				criticalWarn
				text={
					<span>
						<strong>
							Este número foi desativado e deve ser alterado para outro telefone indicado pela
							MaxMilhas. Para alterar,
						</strong>
						<a
							onClick={() => {
								setShowModalPhone(true);
							}}
							className="area-text--link"
						>
							<strong>clique aqui.</strong>
						</a>
					</span>
				}
			/>

			{twoFactorData.is2FAEnabled && !twoFactorData.code && (
				<div className="mt-16">
					<Callout show warn text={<span>{twoFactorData.completionAlert}</span>} />
				</div>
			)}

			<ModalLatamPhone
				show={showModalPhone}
				close={() => setShowModalPhone(false)}
				confirm={onChangePhone}
				phoneSugestion={phoneMMSuggestion}
				phone={phone}
				updateLatamPhone
			/>
		</div>
	);
};

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => {
	return {
		refreshOffers: () => dispatch(refreshOffers())
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(EditOfferRegistered);
